import React from "react"

const SmileIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2299_2236)">
        <path
          d="M8.63355 15.6923C12.3104 15.885 15.4473 13.0605 15.64 9.38366C15.8327 5.70681 13.0082 2.56992 9.33136 2.37723C5.65451 2.18453 2.51762 5.009 2.32492 8.68585C2.13223 12.3627 4.95669 15.4996 8.63355 15.6923Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.24951 10.2266C6.24951 10.2266 7.17836 11.6104 8.84274 11.6976C10.5071 11.7849 11.5755 10.5057 11.5755 10.5057"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.08984 6.93262L7.09733 6.93301"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.0845 7.1416L11.092 7.14199"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2299_2236">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(1.41211 0.626953) rotate(3)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SmileIcon
